module.exports = __webpack_public_path__ + "img/img (46).1eefefba.png";